export default __webpack_public_path__ + "static/Agents-9924d09fd068fad9ac0efed908841750.png";